import React from "react";
import { CalendarDays, MapPin, Clock, Flag, Package, Map, Car, Phone, ListChecks } from "lucide-react";
import { SectionHeading } from "../../components/ui/SectionHeading";
import { StickerCard } from "../../components/ui/StickerCard";
import { CloudsLayer } from "../../components/ui/Decorations";
import { EVENT } from "../../data/mockData";
import { ASSETS } from "../../data/assets";

const INFO = [
  { icon: CalendarDays, label: "Tanggal", value: EVENT.dateLabel },
  { icon: MapPin, label: "Lokasi", value: EVENT.venue },
  { icon: Clock, label: "Gate Buka", value: EVENT.gatesOpen },
  { icon: Flag, label: "Race Start", value: EVENT.raceStart },
  { icon: Package, label: "Racepack Collection", value: EVENT.racepack },
  { icon: Map, label: "Peta Venue", value: "Segera diumumkan (placeholder)" },
  { icon: Car, label: "Parkir", value: "Info parkir menyusul (placeholder)" },
  { icon: ListChecks, label: "Jadwal Acara", value: "Rundown lengkap menyusul (placeholder)" },
];

export default function EventInfo() {
  return (
    <div>
      <section className="relative overflow-hidden pt-10 pb-4">
        <CloudsLayer />
        <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
          <SectionHeading eyebrow="Event Info" title="Semua yang Perlu Kamu Tahu" subtitle="Informasi resmi akan terus diperbarui menjelang hari-H." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-5xl mx-auto px-4 grid sm:grid-cols-2 gap-5">
          {INFO.map((i) => (
            <StickerCard key={i.label} className="p-5 flex items-start gap-4" data-testid={`eventinfo-${i.label}`}>
              <div className="w-12 h-12 rounded-2xl bg-sky/20 text-sky-dark flex items-center justify-center shrink-0">
                <i.icon className="w-6 h-6" />
              </div>
              <div>
                <p className="text-xs uppercase font-bold text-sea-deep/50">{i.label}</p>
                <p className="mt-1 font-display text-lg text-sea-deep">{i.value}</p>
              </div>
            </StickerCard>
          ))}
        </div>

        <div className="max-w-5xl mx-auto px-4 mt-8">
          <StickerCard className="p-6 flex flex-col sm:flex-row items-center gap-5 bg-lime/15">
            <img src={ASSETS.trioHore} alt="" className="w-40 sm:w-52" />
            <div>
              <h3 className="font-display text-xl text-sea-deep flex items-center gap-2"><Phone className="w-5 h-5 text-coral" /> Butuh Bantuan?</h3>
              <p className="mt-1 font-semibold text-sea-deep/70 text-sm">Hubungi tim kami untuk pertanyaan seputar event.</p>
              <p className="mt-2 font-display text-sea-deep">{EVENT.contactEmail}</p>
              <p className="font-display text-sea-deep">{EVENT.contactPhone}</p>
            </div>
          </StickerCard>
        </div>
      </section>
    </div>
  );
}
